import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from '../header';
import Aside from '../aside';
import Main from '../main';
import Sidebar from '../Sidebar';
import Overlay from "../overlay";
import Preloader from '../../components/UI/Preloader';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import { setCorporateColor, setGlobalSearchBoxShow } from './action';
import * as corporateAction from '../../Corporate/corporate/action';
import * as homeAction from '../Home/action';
// import Admin from "../admin";
let corporateColor = 'green';
class Corporate extends Component {
    constructor(props, state) {
        super(props, state);
        this.state = {
            showAlerts: false,
            showMenu: false,
            isOpen: false,
            showSearchResults: false,
            isAdmin: false,
            isCorporate: true,
            searchText: "",
            countryName: "",
            countryCode: "",
            searchParam: "",
            searchResult: [],
            portfolioAlertCount: '',
            innerWidth: "",
            corporateColor: '',
            corporateLogo: null
        };
    }

    showHideSideBar = () => {
        if (window.innerWidth < 1440) {
            this.setState({ showAlerts: !this.state.showAlerts });
        }

    }
    hideSearchBox = (navItemName) =>{
        if(navItemName === "HOME" || window.location.pathname==="/" || window.location.pathname === "/home"){
            this.setState({
                showMenu:false,
                showAlerts:false
        })
        this.props.setGlobalSearchBoxShow(false);
    }               
    }

    showHideEWSMenu =()=>{
        this.setState((prevState) => ({ caseCollapsed: !prevState.caseCollapsed }));
    }

    showHideMenu = () => {
        if (window.innerWidth < 1025) {
            this.setState({ showMenu: !this.state.showMenu })
        }
        this.props.setGlobalSearchBoxShow(true);
        this.props.clearMyPortfolioNavigationFromHome(false);

    }

    showSearchResults = () => {

    }
    handleSearchData = (searchParam, searchText,counteryCode,counteryName) => {
        this.setState(prevState => ({
            showSearchResults: !prevState.showSearchResults,
            searchText: searchText
        }));
        if (searchText) {
            // this.props.searchParameter(searchText);
            let url = new URLSearchParams();
            url.set('s', searchText)
            url.set('country', counteryName)
            url.set('countryCode', counteryCode)
            this.props.history.push(`/search-result/${searchParam}?${url}`)
        }

    }
    componentDidMount() {
        this.setState({
            innerWidth: window.innerWidth
        })
        this.hideSearchBox();
        this.props.setCorporateColor('green');
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.corporateColor !== prevProps.corporateColor) {
            this.setState({
                corporateColor: this.props.corporateColor.colorHexCode,
                corporateLogo: this.props.corporateColor.logoBase64
            })
        }
        if (this.props.corporateColorFailure !== prevProps.corporateColorFailure) {
            this.setState({
                corporateColor: '#407ebc'
            })
        }
        if (this.props.searchText !== prevProps.searchText || this.props.searchParam !== prevProps.searchParam || this.props.countryName !== prevProps.countryName || this.props.countryCode !== prevProps.countryCode) {
            this.setState({
                searchText: this.props.searchText,
                searchParam: this.props.searchParam,
                countryName: this.props.countryName,
                countryCode: this.props.countryCode
            })
        }
        if (this.props.searchData.data !== prevProps.searchData.data) {
            this.setState({
                searchResult: this.props.searchData.data
            })
        }
        if (window.innerWidth !== prevState.innerWidth) {
            if (window.innerWidth >= 1440) {
                this.setState({
                    innerWidth: window.innerWidth,
                    showAlerts: false
                })
            }
            else if (window.innerWidth >= 1025) {
                this.setState({
                    innerWidth: window.innerWidth,
                    showMenu: false
                })
            }
            else {
                this.setState({
                    innerWidth: window.innerWidth
                })
            }
        }
    }
    handleAlertCount = (count) => {
        this.setState({
            portfolioAlertCount: count
        })
    }

    setOverlayFalse = () => {
        this.setState({
            showAlerts: false,
            showMenu: false
        })
    }

    render() {
        const { showAlerts, showMenu } = this.state;
        var cls = "app ";
        if (showAlerts) {
            cls += "sidebar-open ";
        }
        if (showMenu) {
            cls += "aside-open";
        }
        return (
            <section className={cls}>
                <Header
                    showHideSideBar={this.showHideSideBar}
                    showHideMenu={this.showHideMenu}
                    handleSearch={(param, search,counteryCode,counteryName) => this.handleSearchData(param, search,counteryCode,counteryName)}
                    logout={this.props.logout}
                    userInfo={this.props.userInfo}
                    searchText={this.state.searchText}
                    countryName={this.state.countryName}
                    countryCode={this.state.countryCode}
                    searchParam={this.state.searchParam}
                    alertCount={this.state.portfolioAlertCount}
                    corporateColor={this.state.corporateColor}
                    corporateLogo={this.state.corporateLogo}
                    globalSearchBoxShow={this.props.globalSearchBoxShow}                
                    />
                <section className="app-body">
                    <Preloader></Preloader>
                    <Overlay isOpen={this.state.showAlerts || this.state.showMenu} overlayCallback={this.setOverlayFalse}></Overlay>
                    <Aside {...this.props} handleSearchBox={this.hideSearchBox} showHideMenu={this.showHideMenu} corporateColor={this.state.corporateColor} showHideEWSMenu={this.showHideEWSMenu} />
                    <Main {...this.props} corporateColor={corporateColor} />
                    <ToastContainer hideProgressBar={true} position="top-center"></ToastContainer>
                    {/* <Sidebar portfolioAlertcallback={this.handleAlertCount} {...this.props} corporateColor={this.state.corporateColor} /> */}
                </section>
            </section>
        );
    }
}
const mapStateToProps = (state, ownProps) => ({
    searchData: state.corporate.globalSearchResult,
    searchText: state.corporate.searchText,
    countryName: state.corporate.countryName,
    countryCode: state.corporate.countryCode,
    searchParam: state.corporate.searchParam,
    userInfo: state.loginDetails.userDetails.eml,
    corporateColor: state.corporate.corporateColor,
    corporateColorFailure: state.corporate.corporateColorFailure,
    globalSearchBoxShow: state.corporate.globalSearchBoxShow
})

const mapDispatchToProps = (dispatch) => ({
    setCorporateColor: (color) => { dispatch(setCorporateColor(color)) },
    setGlobalSearchBoxShow: (boolean) => {dispatch(setGlobalSearchBoxShow(boolean))},
    setsearchParam: (searchParam) => { dispatch(corporateAction.searchParameter(searchParam)) },
    setsearchText: (searchText) => { dispatch(corporateAction.searchText(searchText)) },
    setCountryName: (countryName) => { dispatch(corporateAction.countryName(countryName)) },
    // searchParameter: (searchText) => { dispatch(action.searchParameter(searchText)) }
    clearMyPortfolioNavigationFromHome :(data) =>{dispatch(homeAction.redirectToPortfolio(data))}

});
export default connect(mapStateToProps, mapDispatchToProps)(Corporate);
